import { UseStore } from 'zustand';
import { createUseExpectedValueChartStore } from '@quantfoliorepo/ui-components';

export const useExpectedValueChartStore: UseStore<any> =
  createUseExpectedValueChartStore();
